import { useTranslation } from 'react-i18next';

function Process() {
  const { t } = useTranslation();
  const steps = t('process.steps', { returnObjects: true });

  return (
    <section id="process" className="section process-section">
      <div className="section-heading align-left">
        <div className="eyebrow">{t('process.eyebrow')}</div>
        <h2>{t('process.title')}</h2>
      </div>

      <div className="process-timeline">
        {steps.map((step) => (
          <div className="process-step" key={step.number}>
            <span>{step.number}</span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Process;
